import { initializeApp } from 'firebase/app';
import { getDatabase, onValue, get, set, ref, remove } from 'firebase/database';
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signOut,
  setPersistence,
  browserLocalPersistence,
  signInWithRedirect,
  getRedirectResult,
} from 'firebase/auth';
import {
  getFirestore,
  query,
  getDocs,
  collection,
  where,
  addDoc,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyD8WLkC6-nwxB8SRoXLS4L9BSgM47auVpE',
  authDomain: 'gift-list-b6912.firebaseapp.com',
  databaseURL: 'https://gift-list-b6912.firebaseio.com',
  projectId: 'gift-list-b6912',
  storageBucket: 'gift-list-b6912.appspot.com',
  messagingSenderId: '154154511202',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const googleProvider = new GoogleAuthProvider();

const handleRedirectResult = async () => {
  try {
    await setPersistence(auth, browserLocalPersistence);
    const result = await getRedirectResult(auth);
    if (result) {
      const user = result.user;
      const q = query(collection(db, 'users'), where('uid', '==', user.uid));
      const docs = await getDocs(q);
      if (docs.docs.length === 0) {
        await addDoc(collection(db, 'users'), {
          uid: user.uid,
          name: user.displayName,
          authProvider: 'google',
          email: user.email,
        });
      }
    }
  } catch (err) {
    console.error('Error handling redirect result:', err);
  }
};

const signInWithGoogle = async () => {
  try {
    // Use localStorage persistence to avoid failures when sessionStorage is inaccessible
    await setPersistence(auth, browserLocalPersistence);

    try {
      const res = await signInWithPopup(auth, googleProvider);
      const user = res.user;
      const q = query(collection(db, 'users'), where('uid', '==', user.uid));
      const docs = await getDocs(q);
      if (docs.docs.length === 0) {
        await addDoc(collection(db, 'users'), {
          uid: user.uid,
          name: user.displayName,
          authProvider: 'google',
          email: user.email,
        });
      }
    } catch (err) {
      // If popup-based sign-in fails (popup blocked or missing initial state), fall back to redirect
      const shouldFallbackToRedirect =
        err?.code === 'auth/operation-not-supported-in-this-environment' ||
        err?.code === 'auth/popup-blocked' ||
        err?.code === 'auth/internal-error' ||
        (err?.message && err.message.toLowerCase().includes('missing initial state'));

      if (shouldFallbackToRedirect) {
        // Redirect will handle the OAuth flow without relying on sessionStorage in the same way
        await signInWithRedirect(auth, googleProvider);
        return;
      }

      throw err;
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};

const database = getDatabase(app);

const subscribeTo = (path, callback) => {
  const db = getDatabase();
  const dbRef = ref(db, path);

  onValue(dbRef, callback);
};

const updateData = (path, data) => {
  const db = getDatabase();
  set(ref(db, path), data);
};

const getData = (path, data) => {
  const db = getDatabase();
  get(ref(db, path, data));
};

const deleteData = (path) => {
  const db = getDatabase();
  remove(ref(db, path));
};

export {
  auth,
  db,
  signInWithGoogle,
  logout,
  subscribeTo,
  getData,
  updateData,
  deleteData,
  handleRedirectResult,
};
